@if (inEditMode) {
	<mat-form-field appStopPropagation class="simAdminSettingsInputFieldUnchanged inTableSettingsFormField" [@zoomInOnEnter] color="accent">
		<mat-label>{{ labelText }}</mat-label>
		@if (usingStringValues) {
			<mat-select [ngModel]="selectedValue" (ngModelChange)="handleStringModelChange($event)">
				@for (value of selectableValues; track value) {
					<mat-option [value]="value">
						{{ value }}
					</mat-option>
				}
			</mat-select>
		}
		@if (!usingStringValues) {
			<mat-select
				[placeholder]="nullValueDisplayOptions?.text"
				[compareWith]="compareWithFunction"
				[ngModel]="selectedValue"
				(ngModelChange)="handleModelChange($event)"
			>
				@if (nullValueDisplayOptions) {
					<mat-option [value]="nullValueDisplayOptions.substituteValue">{{ nullValueDisplayOptions.text }}</mat-option>
				}
				@for (value of selectableValues; track value) {
					<mat-option [value]="value">
						{{ getDisplayValue(value) | translate }}
					</mat-option>
				}
			</mat-select>
		}
	</mat-form-field>
}
@if (!inEditMode) {
	<div [@flyInOut]="load_completed" class="inTableSettingsViewValue">
		<div class="value showDotsOnOverflow wihtoutLineBreak">
			@if (usingStringValues) {
				{{ selectedValue }}
			}
			@if (!usingStringValues) {
				{{ getDisplayValue(selectedValue) | translate }}
			}
		</div>
		<button
			class="copyIcon"
			mat-icon-button
			[matTooltip]="T.SHARED_COPY_VALUE_TOOLTIP | translate"
			matTooltipClass="accent"
			color="accent"
			(click)="copyToClipboard()"
			appStopPropagation
		>
			<mat-icon fontSet="fad" fontIcon="fa-clipboard" />
		</button>
	</div>
}
